import { useSearchParams } from 'react-router-dom';
import { ClipboardCheck, LayoutGrid, List } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import InspectionBoard from '@/components/inspections/InspectionBoard';
import InspectionsRecords from '@/components/inspections/InspectionsRecords';

type View = 'board' | 'records';

/**
 * `/dashboard/inspections`: the month board by default, the full list of records one tap away. The
 * view is in the URL (`?view=records`), so Back from a contract page returns to the view it left.
 */
export default function Inspections() {
    const [params, setParams] = useSearchParams();
    const view: View = params.get('view') === 'records' ? 'records' : 'board';
    const setView = (next: View) => {
        const p = new URLSearchParams(params);
        if (next === 'board') p.delete('view');
        else p.set('view', next);
        setParams(p, { replace: true });
    };

    const toggle = (
        <Tabs value={view} onValueChange={(v) => setView(v as View)}>
            <TabsList>
                <TabsTrigger value="board">
                    <LayoutGrid className="mr-1.5 h-4 w-4" />
                    Board
                </TabsTrigger>
                <TabsTrigger value="records">
                    <List className="mr-1.5 h-4 w-4" />
                    Records
                </TabsTrigger>
            </TabsList>
        </Tabs>
    );

    return (
        <div className="animate-fade-in space-y-6 pt-2 sm:px-6 sm:pt-6 lg:px-8">
            <div>
                <div className="mb-1 flex items-center gap-3">
                    <ClipboardCheck className="h-7 w-7 sm:h-8 sm:w-8" />
                    <h1 className="text-3xl font-semibold tracking-tight sm:text-4xl">Inspections</h1>
                </div>
                <p className="text-muted-foreground">Who has presented this round, which cars are held, and every inspection on record.</p>
            </div>

            {view === 'board' ? <InspectionBoard controlsExtra={toggle} /> : <InspectionsRecords controlsExtra={toggle} />}
        </div>
    );
}
